module.exports = __webpack_public_path__ + "static/media/image-feedback.b9e0424f.png";